export default "__VITE_ASSET__65b1b96c__"